<template>
  <a-modal
    v-model:visible="visible"
    width="720px"
    :title="`Detalles del número “${record.data_parameters?.phone_number}”`"
    centered
    :bodyStyle="modalBodyStyle"
    @cancel="handleClose"
  >
    <div class="container-edit">
      <strong>Información de empresa</strong>
      <div class="profile_picker" v-if="record.channel_id !== ChannelType.WhatsappVoice">
        <ImagePicker
          v-model:value="formStateDetails.picture"
          :src="record.data_parameters?.picture_src"
          isWhatsappPicture
          isSmall
        />

        <div class="details">
          <h3>Foto de tu empresa</h3>
          <p>El tamaño máximo permitido es de 5MB</p>
          <p>Las dimensiones ideales son 640px x 640px</p>
        </div>
      </div>

      <a-form layout="vertical" :model="formStateDetails">
        <a-form-item name="alias">
          <template #label>
            <span
              >Nombre de WhatsApp Business API integrado

              <span class="help">(Alias)</span></span
            >
          </template>

          <a-input v-model:value="formStateDetails.alias" disabled>
            <template #prefix v-if="loadingAlias">
              <LoadingOutlined />
            </template>
          </a-input>
        </a-form-item>

        <template v-if="record.channel_id !== ChannelType.WhatsappVoice">
          <a-form-item name="description" label="Descripción">
            <a-textarea
              v-model:value="formStateDetails.description"
              placeholder="Escribir descripción"
              :autosize="{ minRows: 3, maxRows: 3 }"
              showCount
              :maxlength="250"
            />
          </a-form-item>
  
          <a-form-item name="address" label="Dirección">
            <a-input v-model:value="formStateDetails.address" placeholder="Escribir dirección" />
          </a-form-item>
  
          <a-form-item name="email" label="Correo electrónico">
            <a-input
              v-model:value="formStateDetails.email"
              placeholder="Escribir correo electrónico"
            />
          </a-form-item>
        </template>

        <template v-else>
          <hr />
            <a-form-item name="icon_visibility">
              <template #label>
                <div class="enable-visibility">
                  <span class="title__strong">
                    Mostrar botón de llamada al público (Opcional)
                  </span>
                  <a-switch v-model:checked="formStateDetails.icon_visibility" size="small"/>
                </div>
              </template>
              <p class="info">
                Al activar esta configuración, se mostrará el botón de llamada en tu perfil de empresa en WhatsApp. Tus clientes podrán llamarte directamente en cualquier momento.
              </p>
            </a-form-item>
        </template>
      </a-form>
    </div>

    <!-- <div class="phone-container">
      <img class="waba-phone" :src="wabaPhoneImage" alt="waba-phone" />

      <div class="waba-content">
        <ImagePicker
          :value="formStateDetails.picture"
          :src="record.data_parameters?.picture_src"
          isWhatsappPicture
          isSmall
          isPreview
        />

        <h3>{{ formStateDetails.alias }}</h3>

        <p style="margin-top: 26px">Esta es una cuenta de empresa</p>

        <p style="margin-top: 21px">{{ formStateDetails.description || "\0" }}</p>

        <a-divider type="horizontal" class="divider" />

        <p>{{ formStateDetails.address || "\0" }}</p>

        <a-divider type="horizontal" class="divider" />

        <p class="email">{{ formStateDetails.email || "\0" }}</p>
      </div>
    </div> -->
    <!-- </section> -->

    <template #footer>
      <a-button @click="handleClose">Cancelar </a-button>
      <a-button type="primary" @click="handleSave" :loading="loading" :disabled="!canSave">
        Guardar cambios
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, ref, reactive, computed, watch } from "vue";
import { CopyOutlined } from "@ant-design/icons-vue";
import { isEqual } from "lodash";

import { whatsappProviders } from "@/app/channels/utils/constants";
import { LanguageTypes } from "@/app/shared/utils/enums";
import { cityClient } from "@/app/workspace/services";
import { fetchChannelCustomerById } from "@/app/channels/services";

import SelectorCountry from "@/app/shared/components/selectors/SelectorCountry.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ImagePicker from "@/app/shared/components/molecules/ImagePicker.vue";

import wabaPhoneImage from "@/app/channels/assets/waba-phone.svg?url";
import wppLayoutSmall from "@/app/channels/assets/whatsapp-layout-small.svg?url";
import { LoadingOutlined } from "@ant-design/icons-vue";
import { ChannelType } from "@/app/shared/utils/enums";

const TabsKey = Object.freeze({
  NumberInformation: "information-key",
  Integration: "integration-key",
});

export default defineComponent({
  name: "Editr WhatsApp Integration",
  components: {
    SelectorCountry,
    CopyOutlined,
    CustomScrollbar,
    ImagePicker,
    LoadingOutlined,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    open: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const languages = LanguageTypes;
    const formRef = ref();
    const loadingAlias = ref(false);

    const formState = reactive({
      phone_number: props.record.data_parameters?.phone_number,
      webhook_url: props.record.data_parameters?.url_callback,
      alias: "",
      webhook_url2: "",
      facebook: "",
      radio_group: "si",
      name_company: "",
      country: "",
      type_industry: "",
      name: "",
      last_name: "",
      email: "",
    });

    const compareDetailsForm = reactive({
      picture: undefined,
      alias: "", // props.record.alias,
      description: props.record.data_parameters?.description,
      address: props.record.data_parameters?.address,
      email: props.record.data_parameters?.email,
      icon_visibility: props.record.data_parameters?.icon_visibility,
    });

    const formStateDetails = reactive({
      picture: undefined,
      alias: "", // props.record.alias,
      description: props.record.data_parameters?.description,
      address: props.record.data_parameters?.address,
      email: props.record.data_parameters?.email,
      icon_visibility: props.record.data_parameters?.icon_visibility,
    });

    const rules = {
      phone_number: [],
      webhook_url: [],
      webhook_url2: [],
      facebook: [],
      radio_group: [],
      name_company: [],
      country: [],
      type_industry: [],
      name: [],
      last_name: [],
      email: [],
    };

    const canSave = computed(() => !isEqual(compareDetailsForm, formStateDetails));

    const modalBodyStyle = computed(() => ({
      height: (props.record.channel_id === ChannelType.WhatsappVoice) ? '288px' : '520px', 
      paddingTop: (props.record.channel_id === ChannelType.WhatsappVoice) ? '32px' : '', 
    }))

    const handleFetchDetails = async (id) => {
      loadingAlias.value = true;
      const response = await fetchChannelCustomerById(id);
      const alias = response.alias;
      formState.alias = alias;
      formStateDetails.alias = alias;
      compareDetailsForm.alias = alias;
      console.log(response, "handleFetchDetails");
      loadingAlias.value = false;
    };

    watch(
      () => props.record,
      (value) => {
        handleFetchDetails(value.id);
      },
      { immediate: true }
    );

    return {
      formRef,
      formState,
      formStateDetails,
      rules,
      languages,
      TabsKey,
      canSave,
      modalBodyStyle,
      wabaPhoneImage,
      wppLayoutSmall,
      loadingAlias,
    };
  },
  data() {
    return {
      providers: whatsappProviders,
      cities: [],
      activeKey: TabsKey.NumberInformation,
      loading: false,
      ChannelType,
    };
  },
  computed: {
    visible() {
      return this.open;
    },
    channel() {
      return this.record;
    },
    countries() {
      return this.$store.getters["getAllCountries"];
    },
    industries() {
      return this.$store.getters["getAllIndustries"];
    },
  },
  watch: {
    channel(value) {
      if (value) {
        this.handleGetCities(value.data_parameters.country);
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleCopyError() {
      this.$message.error("Falló");
    },
    handleCopySuccess() {
      this.$message.success("Copiado");
    },
    async handleGetCities(value) {
      this.cities = await cityClient(value);
    },
    async handleSave() {
      const data = {
        id: this.record.id,
        ...this.formStateDetails,
      };
      delete data.alias;

      this.loading = true;

      try {
        await this.$store.dispatch("updateChannelCreate", data);
        this.$message.success("Se guardaron tus cambios");
        this.$emit("update");
        this.handleClose();
      } catch (error) {
        const errorMessage = error?.getErrorMessage() || "Ha ocurrido un error";

        this.$message.error(errorMessage);
      }

      this.loading = false;
    },
  },
});
</script>

<style lang="sass" scoped>
h3, p
  margin: 0

.form
  padding: 0 10px

.title
  padding: 0
  font-size: 14px
  font-weight: 600
  margin-bottom: 8px
  &__strong
    font-weight: 600
    margin-right: 5px

.container-edit
  max-width: 460px
  margin: 0 auto

.number-data__wrapper
  display: grid
  grid-template-columns: 1fr 250px
  gap: 40px
  height: 100%

.phone__wrapper
  background-position: center top
  background-size: auto 100%
  padding-bottom: 178%
  background-repeat: no-repeat

.flag
  width: 20px
  margin-bottom: 2px

span.help
  color: $gray-7

.modal_tabs
  height: 100%
  overflow: visible !important

:deep(.ant-tabs-content.ant-tabs-content-top)
  height: 100%

.ant-divider-horizontal
  min-width: 0

.phone-container
  position: relative
  height: 100%

  .waba
    &-phone
      position: absolute
      inset: 0
      width: 100%
      box-shadow: 5px 5px 40px rgba(24, 48, 63, 0.35)
      border-radius: 23px
      margin: auto 0
      height: 468px

    &-content
      position: relative
      z-index: 2
      display: flex
      flex-direction: column
      align-items: center
      margin-top: 82px

      h3
        color: $gray-9
        font-weight: 600
        font-size: 14px
        margin-top: 8px

      p
        color: #888A92
        font-size: 12px
        line-height: 20px
        flex: 1 1 100%
        align-self: flex-start
        margin: 0 18px
        width: calc(100% - 36px)

        &.email
          color: #02A386

      .divider
        background-color: #F0EFF5
        margin: 4px auto
        max-width: calc(100% - 32px)

.ant-form-item
  margin-bottom: 20px

.profile_picker
  display: flex
  gap: 16px
  margin-top: 20px
  margin-bottom: 20px

.details
  h3
    font-size: 14px
    color: $gray-9
    font-weight: 600

  p
    color: $gray-8

.preview-name
  position: absolute
  bottom: 62px
  left: 0
  right: 0
  margin: 0 auto
  font-weight: 600
  width: 100%
  text-align: center

.label
  width: 100%
  display: flex
  justify-content: space-between
:deep(.ant-form-item-label)
  width: 100%
:deep(label[for="form_item_alias"])
  width: 100%

.enable-visibility
  display: flex
  align-items: center
  gap: 16px

.info
  color: $gray-8
  font-size: 12px
  display: flex
  margin-bottom: 8px

hr
  height: 1px
  background-color: $gray-4
  border: none
  margin-top: 20px
  margin-bottom: 20px

:deep(.ant-tabs-tabpane)
  padding: 10px 0
  height: max(60vh, 600px)
</style>
